<template>
  <div>
    <CCard>
      <CCardHeader>
        <b>{{ $i18n.t("licitadores.nuevo") }}</b>
      </CCardHeader>
      <CCardBody>
        <CRow form class="form-group">
          <CCol sm="12">
            <CInput
              label="Nombre del licitador"
              type="text"
              @change="handleNombreLicitador"
              horizontal
            />
          </CCol>
        </CRow>
        <CRow form class="form-group">
          <CCol sm="12">
            <CInput
              label="DNI / CIF"
              type="text"
              @change="handleDNICIF"
              horizontal
            />
          </CCol>
        </CRow>
        <CRow form class="form-group">
          <CCol>
            <CButton color="info" @click="guardarLicitador"
              >Guardar licitador</CButton
            >
            
          </CCol>
        </CRow>
        <div v-if="mostrarError" style="color: red">{{mensajeError}}</div>
      </CCardBody>
    </CCard>
  </div>
</template>

<style scoped>
</style>

<script>
import Cookies from "js-cookie";
import { crearLicitador } from "../../requests/licitadores";

export default {
  name: "NuevoLicitador",
  components: {},
  created() {},
  mounted() {},
  data() {
    return {
      stateOptions: ["Válido", "No válido"],
      licitador: {
        nombre: "",
        dnicif: "",
      },
      mensajeError: "",
      mostrarError: false
    };
  },
  methods: {
    handleNombreLicitador(value) {
      this.licitador.nombre = value;
    },
    handleDNICIF(value) {
      this.licitador.dnicif = value;
    },
    guardarLicitador() {
      if (this.licitador.dnicif == "" || this.licitador.nombre == "") {
        this.mostrarInformacion("No puede estar ningún campo vacío.");
        return;
      }
      crearLicitador(this.licitador)
        .then((res) => {
          this.$router.push({ path: "/licitadores/lista?event=created" });
        })
        .catch((error) => {
          this.mostrarInformacion(
            "<b>" +
              error.response.data.error +
              "</b>"
          );
        });
    },
    mostrarInformacion(mensaje) {
      //muestra informacion usando el modal de modificar
      this.mensajeError = mensaje;
      this.mostrarError = true;
    },
  },
  beforeDestroy() {},
};
</script>
